import { PFTOverreading, TestRepeatabilityResults, Parameters, LungVolumeTestAcceptabilitySummary, TestResults, LungVolumeResults } from "../../PulmonaryFunctionTests/Shared/PFTAPITypes";
import { ParameterTypeName } from "../../misc/api/ParameterTypes";


export function MapLungVolumeTestAcceptabilitySummaries(testResults: TestResults[]): Array<LungVolumeTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            TestId: tr.TestId,
            Accepted: tr.OverreaderAcceptability,
            Frc: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_FRC).Value,
            Tlc: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_TLC).Value,
            Erv: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_ERV).Value,
            Rv: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_RV).Value,
            Vc: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_VC).Value,
            Ic: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_IC).Value,
            RvTlc: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_RVTLC).Value,
            Cev: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_CEV).Value,
            Lci: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_Lci).Value,
        } as LungVolumeTestAcceptabilitySummary;
    });
}
